import ACTION_TYPE from '../../store/ACTION_TYPE';
import reactors from '../../store/reactors';

const defaultState = {};

type Action = {
    type: ACTION_TYPE;
};

/* eslint-disable-next-line default-param-last */
export default function lifecycleReducer(state = defaultState, action: Action) {
    if (action.type.includes('FILTER')) {
        reactors.cancelQuietPeriod();
    }

    return { ...state, appTime: Date.now() };
}
